# contains 'simple' actions that can be tracked and reported to tracking hub
class TrackingHelper
  constructor: ->
    @recordedFirstPage = false

  pageReady: ->
    if @recordedFirstPage then return
    if not Groupon.Performance then return

    Groupon.Performance.pageReady()

    @recordedFirstPage = true

module.exports = TrackingHelper
